"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isShowPostIlEmpoleeDiscount = exports.isPostIlEmpolee = void 0;
var _helpers = require("./helpers");
var agentDeveloperName = _helpers.agentDeveloperUtils.getAgentDeveloperName;
var output = null;
var getSessionStorageItem = function getSessionStorageItem() {
  if (agentDeveloperName === 'Post_IL') {
    if (output === null) {
      var offersFields = sessionStorage.getItem('offers_fields');
      var parsedFields = offersFields ? JSON.parse(offersFields) : null;
      output = {
        policyType: parsedFields === null || parsedFields === void 0 ? void 0 : parsedFields.policyType,
        utmSource: parsedFields === null || parsedFields === void 0 ? void 0 : parsedFields.source
      };
    }
  }
};
var isPostIlEmpolee = function isPostIlEmpolee() {
  var _output;
  getSessionStorageItem();
  if (((_output = output) === null || _output === void 0 ? void 0 : _output.utmSource) === 'postins-employee' && agentDeveloperName === 'Post_IL') {
    return true;
  }
  return false;
};
exports.isPostIlEmpolee = isPostIlEmpolee;
var isShowPostIlEmpoleeDiscount = function isShowPostIlEmpoleeDiscount() {
  var _output2;
  if (isPostIlEmpolee() && ((_output2 = output) === null || _output2 === void 0 ? void 0 : _output2.policyType) === 'FULLCOVER') {
    return true;
  }
  return false;
};
exports.isShowPostIlEmpoleeDiscount = isShowPostIlEmpoleeDiscount;